import { NativeModule } from "expo";

import type {
  Device,
  ExpoTvConnectRemoteModuleEvents,
} from "./ExpoTvConnectRemote.types";

class ExpoTvConnectRemoteModule extends NativeModule<ExpoTvConnectRemoteModuleEvents> {
  configure(): void {
    throw new Error("Not supported on this platform");
  }

  async startDiscovery(): Promise<void> {
    throw new Error("Not supported on this platform");
  }

  async stopDiscovery(): Promise<void> {
    throw new Error("Not supported on this platform");
  }

  async getDiscoveredDevices(): Promise<Device[]> {
    throw new Error("Not supported on this platform");
  }

  async connect(): Promise<void> {
    throw new Error("Not supported on this platform");
  }

  async disconnect(): Promise<void> {
    throw new Error("Not supported on this platform");
  }

  getConnectedDevice(): Device | null {
    throw new Error("Not supported on this platform");
  }

  async sendMessage(): Promise<void> {
    throw new Error("Not supported on this platform");
  }
}

export default new ExpoTvConnectRemoteModule();
